module.exports = __webpack_public_path__ + "static/media/left-side.72644fdc.png";